import {Component, Inject, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {ApproveSickDay, GetSickDayAnswers} from '@app/core/store/actions/sick-days.actions';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {ISickDay} from '@app/core/interfaces/sick-days.interface';
import {EQOColor, EQOIcon, EQORebrandColor, EQORebrandIcon, EQOScreenSize} from '@quickorder/angular-web-lib';
import {Observable} from 'rxjs';
import {ISickDayAnswer} from '@app/core/interfaces/sick-day-answer';
import {selectIsSickDaysLoading, selectSickDayAnswers} from '@app/core/store/selectors/sick-days.selectors';
import {ESICKDAYANSWERTYPE} from '@app/core/enums';
import {User} from '@app/core/models/user.model';
import {AuthService} from '@app/core/services/auth.service';

@Component({
	selector: 'app-sick-day-answers',
	templateUrl: './sick-day-answers.component.html',
	styleUrls: ['./sick-day-answers.component.scss'],
})
export class SickDayAnswersComponent implements OnInit {
	public SCREEN = EQOScreenSize;
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;

	public ANSWER = ESICKDAYANSWERTYPE;
	public answers$: Observable<ISickDayAnswer[]> = this.store.select(selectSickDayAnswers);
	public isLoading$: Observable<boolean> = this.store.select(selectIsSickDaysLoading);

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { sickDay: ISickDay },
		private store: Store<IAppState>,
		public authService: AuthService,
		private dialog: MatDialog,
	) {
	}

	public ngOnInit(): void {
		if (!this.data.sickDay) {
			return;
		}
		this.store.dispatch(new GetSickDayAnswers(this.data.sickDay));
	}

	public allocateShift(user: User): void {
		this.store.dispatch(new ApproveSickDay(this.data.sickDay, user.id));
	}

	public close(): void {
		this.dialog.getDialogById('sickDayAnswersDlg')?.close();
	}
}
